export default {"src":"/_next/static/media/my-payment-methods.31ce24fa.svg","height":12,"width":17,"blurWidth":0,"blurHeight":0};